import React from "react";
import { purchaseOrderFields } from "../formFields.js/PurchaseOrderFields";
import CommonFormTab from "./CommonFormTab";

export default function PurchaseOrderTab({ formData, onChange, readOnly, formSubmissionAttempted, mode = 'create' }) {
  return (
    <CommonFormTab
      fields={purchaseOrderFields}
      formData={formData}
      onChange={onChange}
      readOnly={readOnly}
      formSubmissionAttempted={formSubmissionAttempted}
      mode={mode}
    />
  );
}